import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { surgeryOptionsRootKey } from "./selectSurgeryOptions";

/**
 * Builder (admin) list: every surgery option of the base table. Pickers read `available_surgery_options`,
 * which no longer bypasses the visibility rule for admins.
 */
async function selectSurgeryOptionsForBuilder() {
    const { data, error } = await supabaseClient.from("surgery_options").select("*");
    if (error) throw error;
    return data;
}

export const surgeryOptionsBuilderQueryKey = [...surgeryOptionsRootKey, "builder"];

export const selectSurgeryOptionsBuilderQueryOptions = () => {
    return queryOptions({
        queryKey: surgeryOptionsBuilderQueryKey,
        queryFn: () => selectSurgeryOptionsForBuilder(),
    });
};

export function useSelectSurgeryOptionsForBuilder() {
    return useQuery(selectSurgeryOptionsBuilderQueryOptions());
}
